import type { ReactNode, CSSProperties } from 'react';

import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import STYLES from './Section.module.scss';

type Props = {
  testId?: string;
  className?: string;
  padded?: boolean;
  title?: ReactNode;
  node?: ReactNode;
  style?: CSSProperties;
};

const Section = ({
  className,
  node,
  padded,
  testId,
  title,
  ...rest
}: Props) => {
  if (!node) {
    return null;
  }

  const classNames = [STYLES.Section];
  if (className) {
    classNames.push(className);
  }

  if (padded) {
    classNames.push(STYLES.Section__padded);
  }

  return (
    <div className={classNames.join(' ')} data-test-id={testId} {...rest}>
      <div className={STYLES.Section__content}>
        {title ? (
          <BpkText
            textStyle={TEXT_STYLES.subheading}
            tagName="h2"
            className={STYLES.Section__title}
          >
            {title}
          </BpkText>
        ) : null}
        {node}
      </div>
    </div>
  );
};

export default Section;
